module.exports = __webpack_public_path__ + "static/img/team3-blue.5fd650c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team3-blue.png
// module id = TZai
// module chunks = 0